import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cdaabea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "success" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "main-content-page-title w-full pb-2" }, "お問合せ", -1))
const _hoisted_3 = { class: "content mt-8" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center pt-5" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xl" }, "お問い合わせいただきましてありがとうございます。"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-xl" }, "2~3営業日以内にはご連絡させていただきます。")
], -1))
const _hoisted_5 = { class: "col-12 flex justify-content-center mt-3 pr-0" }

import RouterConstants from "@/clinic/constants/router.constants";
import RouterUtils from "@/common/utils/router.util";

export default /*#__PURE__*/_defineComponent({
  __name: 'success',
  setup(__props) {

const backToDashboard = () => {
  return RouterUtils.goTo(RouterConstants.DASHBOARD_ROUTER_NAME);
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Button, {
          label: "ダッシュボードへ戻る",
          onClick: backToDashboard
        })
      ])
    ])
  ]))
}
}

})